import { render } from "./footer.vue?vue&type=template&id=c55593e2"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jmallach/Dev/jicub/vuejs-bosb-microsite/my-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__